import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { Meter } from "./meter"
import { IMeter } from "./meter.types"
import {
  MeterRegisterParser,
  IRegisterRaw,
} from "../meterRegister/meterRegister.parser"
import type { IMeterpointRaw } from "../meterpoint/meterpoint.parser"

export type IMeterRaw = NonNullable<IMeterpointRaw["meters"][number]>

export const MeterParser: IParser<IMeter, IMeterRaw> = {
  toDomain: (data: IMeterRaw) => {
    try {
      return new Meter(
        data.id,
        data.identifier,
        data.meterType,
        data.meterTypeDescription,
        data.registers
          .filter((register): register is IRegisterRaw => register !== null)
          .map((register) => MeterRegisterParser.toDomain(register)),
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
